import React from 'react';
import { _T } from '../../../include/appI18n';
import { appUrl } from '../../../include/utils';
import './capital-cart.css';
/** Also rendered by the Capital Razor entry when the initial cart has no services. */
export function CapitalCartEmpty() {
    return React.createElement("section", { className: "capital-cart-empty", "aria-labelledby": "capital-cart-empty-title" },
        React.createElement("img", { src: appUrl('/Content/capital/assets/cart-empty.svg'), alt: "" }),
        React.createElement("h1", { id: "capital-cart-empty-title" }, _T.CART_NO_SERVICES),
        React.createElement("div", { className: "capital-cart-empty-actions" },
            React.createElement("a", { href: appUrl('/Tour') }, "\u041A \u0442\u0443\u0440\u0430\u043C"),
            React.createElement("a", { href: appUrl('/PrivateOffice') }, "\u0412 \u043F\u0440\u043E\u0444\u0438\u043B\u044C")));
}
